export default {
  "privacy-policy": "https://www.vodafone.nl/support/over-deze-website/privacy-en-disclaimer",
  "terms-and-conditions": "https://www.vodafone.nl/support/abonnement-en-rekening/tarieven-en-voorwaarden",
  "help-and-support": "https://www.vodafone.nl/support",
  "cookie-preferences": "cookie-preferences",
};
